module.exports = __webpack_public_path__ + "img/icon_03.d4b4afee.png";